export enum GatewayStatus {
  HEALTHY = 'HEALTHY',
  UNHEALTHY = 'UNHEALTHY',
  UNREGISTERED = 'UNREGISTERED',
  GREENGRASS_NUCLEUS_STALE = 'GREENGRASS_NUCLEUS_STALE',
  GREENGRASS_COMMUNICATION_ERROR = 'GREENGRASS_COMMUNICATION_ERROR',
  GREENGRASS_DEPLOYING = 'GREENGRASS_DEPLOYING',
  S3_BUCKET_ERROR = 'S3_BUCKET_ERROR',
  S3_STATUS_PENDING = 'S3_STATUS_PENDING',
}

// keep in sync with services/instruments/client/openapi.yaml GatewayType
export enum GatewayType {
  GREENGRASS = 'GREENGRASS',
  S3 = 'S3',
  SNOWFLAKE = 'SNOWFLAKE',
}

export const GATEWAY_TYPE_TO_DISPLAY: Record<GatewayType, string> = {
  [GatewayType.GREENGRASS]: 'Local Windows',
  [GatewayType.S3]: 'S3 Cloud',
  [GatewayType.SNOWFLAKE]: 'Snowflake',
};

// Maps gateway types to the instrument type name used to resolve the adapter manifest.
// The getAdapter API resolves adapters by instrument type name, not adapter name.
// Gateway types absent from this map (e.g. GREENGRASS) have no adapter-driven
// fields to display on the gateway modal.
export const GATEWAY_TYPE_TO_INSTRUMENT_TYPE: Partial<Record<GatewayType, string>> = {
  [GatewayType.S3]: 'file-watcher-adapter',
  [GatewayType.SNOWFLAKE]: 'snowflake-adapter',
};

// Single client-side source of truth for S3-gateway field IDs. Any code that references a
// specific field by id (CloudFormation template, bucket-policy helper, read
// sites that need the bucket name) must go through this.
export const S3_FIELD_IDS = {
  CUSTOMER_BUCKET: 'customer_bucket',
  CUSTOMER_ROLE_ARN: 'customer_role_arn',
} as const;

export enum S3PermissionMode {
  IAM_ROLE = 'iam_role',
  BUCKET_POLICY = 'bucket_policy',
}

export interface InstrumentGateway {
  // TODO Other attributes on GatewayResource are also nullable, but not in practice, fix in openapi.yaml
  id: string;
  name: string;
  gatewayType: GatewayType;
  status: GatewayStatus;
  isArchived: boolean;
  installerVersion?: string;
  jdkVersion?: string;
  fields?: {[id: string]: string | null};
  tokenDownloadUrl?: string;
}

export const GENERIC_UPDATE_FAILURE_MESSAGE =
  'Failed to update gateway. Please check your input and try again.';

export function stringFields(fields: InstrumentGateway['fields']): Record<string, string> {
  const result: Record<string, string> = {};
  for (const [id, value] of Object.entries(fields ?? {})) {
    if (typeof value === 'string') {
      result[id] = value;
    }
  }
  return result;
}
